const URL = process.env.REACT_APP_MANUAL;
export const ENDPOINTS = {
  brands: `${URL}/brands`,
  manualtypes: `${URL}/manualtypes`,
  productfamilies: `${URL}/productfamilies`,
  languages: `${URL}/languages`,
  search: `${URL}/search`
};

export const brands = async () => {
  const res = await fetch(ENDPOINTS.brands, {
    method: 'GET'
  });
  return res.ok ? res.json() : null;
};

export const manualtypes = async () => {
  const res = await fetch(ENDPOINTS.manualtypes, {
    method: 'GET'
  });
  return res.ok ? res.json() : null;
};

export const languages = async () => {
  const res = await fetch(ENDPOINTS.languages, {
    method: 'GET'
  });
  return res.ok ? res.json() : null;
};

export const productfamilies = async values => {
  const res = await fetch(ENDPOINTS.productfamilies, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(values)
  });
  return res.ok ? res.json() : null;
};

export const search = async values => {
  const res = await fetch(ENDPOINTS.search, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(values)
  });
  return res.ok ? res.json() : null;
};
